import React from 'react';
import PropTypes from 'prop-types';

import GridNav from '../content/grid/GridNav';

import usePlaylistsNav from '../../../hooks/usePlaylistsNav';

function DNavPlaylists(props) {
  let { id, pathApi, width, rowCount, rowWidth, perPage, style } = props;
  const perPageCal = perPage ?? Math.floor(width / rowWidth) * rowCount;
  const [dataHook] = usePlaylistsNav(id, pathApi, perPageCal, 'CHART-NAV');

  return <GridNav {...props} dataHook={dataHook} style={{ ...style }} />
}

DNavPlaylists.propTypes = {
  id: PropTypes.string.isRequired,
  width: PropTypes.any,
  height: PropTypes.number.isRequired,
  pathApi: PropTypes.string.isRequired,
  rowCount: PropTypes.number,
  rowHeight: PropTypes.number,
  columnCount: PropTypes.number,
  style: PropTypes.object,
}

export default DNavPlaylists;
